import React from "react";
import { TableBody } from "@mui/material";

import OverlappingAbsencesRow from "./OverlappingAbsencesRow/OverlappingAbsencesRow";
import { TnAAbsenceDTO } from "../../../../../../models/tna";

interface Props {
  absences: TnAAbsenceDTO[];
}

const OverlappingAbsencesTableBody = ({ absences }: Props) => {
  return (
    <>
      <TableBody>
        {absences.map((absence, idx) => {
          return (
            <OverlappingAbsencesRow
              key={absence?.id ?? idx}
              absence={absence}
            />
          );
        })}
      </TableBody>
    </>
  );
};

export default OverlappingAbsencesTableBody;
